import React, { useContext, useEffect } from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router'

import { removeAuthHeader } from 'utils'
import { UserContext } from 'contexts'
import { ReactComponent as LogoPC } from 'assets/images/main-logo-punta-carretas.svg'
import { useApiCall } from 'hooks'
import { GetStyleResponse } from 'features/Main/Styles/types'
import { getStyles } from 'features/Main/Styles/api'

import { useStyles } from './styles'

interface Props {
  isLoggedIn?: boolean
}

const NavBar: React.FC<Props> = ({ isLoggedIn }) => {
  const classes = useStyles()
  const { setAdmin } = useContext(UserContext)
  const history = useHistory()
  const onLogout = () => {
    localStorage.clear()
    removeAuthHeader()
    setAdmin(undefined)
    history.push('/login', { from: history.location })
  }

  const [styleApi] = useApiCall<void, GetStyleResponse>(getStyles)

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        await styleApi()
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      } catch (error) {
        console.error('Error fetching theme data:', error)
      }
    }

    fetchTheme()
  }, [styleApi])

  const getNavbarLogo = () => {
    return <LogoPC height={50} width={200} />
  }

  return (
    <AppBar position="fixed" className={classes.appBar} elevation={0} color="inherit">
      <Toolbar>
        {getNavbarLogo()}
        {isLoggedIn && (
          <Button color="inherit" className={classes.logout} onClick={onLogout}>
            Cerrar sesión
          </Button>
        )}
      </Toolbar>
    </AppBar>
  )
}

NavBar.defaultProps = {
  isLoggedIn: false,
}

export { NavBar }
